// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21dp3","col":"styles_col__2E4jo"};